import * as React from "react"
import { useTranslation } from "react-i18next"
import Block from "@bappweb/block"
import { Sizes, useDeviceSize } from "@bappweb/provider"
import Link from "@bappweb/link"
import LogoAkbankApiPortal from "@components/commonmodules/logo"
import "./style.scss"

const Footer = () => {
  const { t } = useTranslation()
  const size = useDeviceSize()

  return (
    <Block type="footer" className="bapp-footer">
      <Block className="bapp-footer-wrapper bapp-container">
        <LogoAkbankApiPortal isMobile={size === Sizes.xs} />
        <Block type={"nav"}>
          <Link href={"https://akbank.com"}>{t("Akbank")}</Link>
          <Link href={"https://akbank.com"}>{t("Akbank Direkt")}</Link>
          <Link href={"https://akbank.com"}>{t("Nearest Akbank")}</Link>
        </Block>
      </Block>
    </Block>
  )
}

export default Footer
